import { DistrictDetailsEffects } from './details.effects';
import { DistrictSearchResultsEffects } from './district-searchresults.effect';

export const effects: any[] = [DistrictDetailsEffects, DistrictSearchResultsEffects];

export * from './details.effects';
export * from './district-searchresults.effect';
